import NotOptedIn from 'components/NotOptedIn';
import SidebarContext from 'state/SidebarContext';
import FiksFerdig from './components/FiksFerdig';
import useHideFouc from './hooks/useHideFouc';
import { DataProps } from './types/uiTypes';
import useDataProps from './hooks/useDataProps';

const App = () => {
    const { uiText, finnkode, isOwnAd, isExperiment }: DataProps = useDataProps();
    const loading = useHideFouc();
    if (!uiText) return null;
    const {
        sections: {
            sidebar: { optedIn, notOptedIn },
        },
    } = uiText;

    const context = {
        isExperiment,
        finnkode,
        uiText,
        isOwnAd,
    };

    if (loading) {
        return null;
    }
    return (
        <SidebarContext.Provider value={context}>
            {optedIn && <FiksFerdig />}
            {notOptedIn && <NotOptedIn />}
        </SidebarContext.Provider>
    );
};
export default App;
